export function helloWorld() {
	return (dispatch) => {
		dispatch({
			type: "HELLO_WORLD",
		});
	};
}
